import { render, staticRenderFns } from "./bindingCard.vue?vue&type=template&id=9379c2c8"
import script from "./bindingCard.vue?vue&type=script&lang=js"
export * from "./bindingCard.vue?vue&type=script&lang=js"
import style0 from "./bindingCard.vue?vue&type=style&index=0&id=9379c2c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports